import React from "react";
import {
  ActivityCalendar,
  AuditHistory,
  DynamicTab,
  NewTab,
  PageTab,
} from "../../../../components";
import { ActivityCalendarList } from "./CalendarList/ActivityCalendarList";
import AuditHistoryList from "./CalendarList/AuditHistoryList";
import DailyProductionList from "./DailyProductionList";
import { useLocation } from "react-router-dom";

const CalendarList = () => {
  const location = useLocation();
  const fullHashPath = location.hash.slice(1).split("/");
  const tabList = [
    {
      title: "Activity Calendar",
      page: <ActivityCalendarList />,
      type: "main",
    },
    {
      title: "Audit History",
      page: <AuditHistoryList />,
      type: "main",
    },
    {
      title: "Daily Production Table",
      page: <DailyProductionList />,
      type: "main",
    },
  ];
  return (
    <div className="w-full p-2 flex flex-1 overflow-hidden">
      <NewTab
        tabs={tabList}
        color="black"
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="calendar-list"
      />
    </div>
  );
};

export default CalendarList;
